import { can, PortalPermissions } from "../../../config/permissions";
import React, {useEffect, useMemo, useState,} from 'react';
import {T2} from '../../../styles/titles';
import LoadingOverlay from '../../../components/LoadingOverlay';
import {Col, Row} from "antd";
import {Container, DateView} from './styles';
import FormInput from "../../../components/Forms/Input";
import {Field, Form, Formik} from 'formik';
import DatePickerField from "../../../components/DatePicker";
import SelectField from "../../../components/Select";
import {ISelectValue} from "../../../global/types";
import {
  AlignCheckbox,
  Button,
  CheckboxContainer,
  CheckboxTitle
} from "../../business/newBusiness/components/Form/style";
import {useHistory} from "react-router-dom";
import {toast} from "react-toastify";
import LinkDePagamentoService from "../service/linkDePagamentoService";

interface FormValues {
  name: string;
  valueReais: string;
  dataExpiracao: Date | null;
  description: string;
  parcelas: ISelectValue | null;
  credito: boolean;
  debito: boolean;
  pagamentoUnico: boolean;
  threeDSEnable?: boolean
}

const CadastrarLinks: React.FC = () => {
  const history = useHistory();
  const linkDePagamentoServices = new LinkDePagamentoService();
  const selectedBusiness = localStorage.getItem('selectedCompany') ? JSON.parse(localStorage.getItem('selectedCompany') as string) : null;
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(0);
  useEffect(() => {
    //@ts-ignore
    const user = JSON.parse(localStorage.getItem('userInfo'));
    setUserId(user.id);
  }, []);

  const cadastraLink = async (submit: any) => {
    setLoading(true);

    try {
      await linkDePagamentoServices.createLink(submit);
      history.push('/listar-links');
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const handleSetCurrencyMask = useMemo(() => (
    e: React.FormEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    name: string,
  ): React.FormEvent<HTMLInputElement> => {
    let {value} = e.currentTarget;

    value = value.replace(/\D/g, '');
    value = value.replace(/(\d)(\d{2})$/, '$1,$2');
    value = value.replace(/(?=(\d{3})+(\D))\B/g, '.');

    e.currentTarget.value = value;
    setFieldValue(name, value);
    return e;
  }, []);

  const parcelas: ISelectValue[] = [
    {label: '1', value: '1'},
    {label: '2', value: '2'},
    {label: '3', value: '3'},
    {label: '4', value: '4'},
    {label: '5', value: '5'},
    {label: '6', value: '6'},
    {label: '7', value: '7'},
    {label: '8', value: '8'},
    {label: '9', value: '9'},
    {label: '10', value: '10'},
    {label: '11', value: '11'},
    {label: '12', value: '12'},
    {label: '13', value: '13'},
    {label: '14', value: '14'},
    {label: '15', value: '15'},
    {label: '16', value: '16'},
    {label: '17', value: '17'},
    {label: '18', value: '18'},
    {label: '19', value: '19'},
    {label: '20', value: '20'},
    {label: '21', value: '21'},
  ];

  const formatDateToYYYYMMDD = (date: any) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  return (
    <Container>
      <LoadingOverlay
        show={loading}
        relative
      />

      <T2>Cadastrar link de pagamento</T2>
      <Formik<FormValues>
        onSubmit={async (values: any) => {
          if (values.name == '') {
            toast.error('Nome do produto é obrigatório!');
            return;
          }

          if (values.value == '') {
            toast.error('Valor é obrigatório!');
            return;
          }

          if (values.dataExpiracao == null) {
            toast.error('Data de expiração é obrigatório!');
            return;
          }

          if (values.description == '') {
            toast.error('Descrição é obrigatório!');
            return;
          }


          if (values.parcelas != null) {
            values.installment = {};
            values.installment.installment_limit = parseInt(values.parcelas.value);
          } else {
            values.installment = {};
            values.installment.installment_limit = 1;
          }
          values.payment_methods = [];
          values.payment_methods.push('CREDIT');

          if (values.payment_methods.length == 0) {
            toast.error('Selecione pelo menos uma forma de pagamento!');
            return;
          }

          if (values.dataExpiracao != null) {
            values.expires_at = formatDateToYYYYMMDD(values.dataExpiracao);
          }

          if (values.pagamentoUnico) {
            values.sales_limit = 1;
          }

          values.usuario_id = userId;
          const normalizedValue = values.valueReais.replace(/\./g, '').replace(',', '.');
          const numberValue = parseFloat(normalizedValue);
          values.value = numberValue * 100;

          cadastraLink(values);
        }}
        initialValues={{
          name: '',
          valueReais: '',
          dataExpiracao: null,
          description: '',
          parcelas: {label: '1', value: '1'},
          credito: false,
          debito: false,
          pagamentoUnico: false,
        }}>

        {({setFieldValue, values}) => (
          <Form>
            <Row gutter={18} align="top" justify="start">
              <Col span={12}>
                <FormInput
                  type="text"
                  name="name"
                  label="Nome do produto"
                  required
                  placeholder="O que você está vendendo"
                />
              </Col>
              <Col span={12}>
                <FormInput
                  type="text"
                  name="valueReais"
                  label="Valor"
                  required
                  placeholder="0,00"
                  prefix="R$"
                  onChange={(e: React.FormEvent<HTMLInputElement>) => handleSetCurrencyMask(e, setFieldValue, 'valueReais')}
                />
              </Col>
            </Row>
            <Row gutter={18} align="top" justify="start">
              <Col span={12}>
                <DateView>
                  <DatePickerField
                    name="dataExpiracao"
                    label="Expira em"
                    required
                    placeholder="Data de expiração"
                  />
                </DateView>
              </Col>
              <Col span={12}>
                <FormInput
                  type="text"
                  name="description"
                  label="Descrição do link"
                  required
                  placeholder="Descrição do produto ou serviço"
                />
              </Col>
            </Row>


            <Row gutter={18} align="top" justify="start">


              <Col span={12}>
                <SelectField
                  name="parcelas"
                  label="Parcelas"
                  options={parcelas}
                  placeholder="Quantidade máxima de parcelas"
                />
              </Col>

              <Col span={6}>
                <CheckboxContainer>
                  <AlignCheckbox>
                    <Field
                      name="pagamentoUnico"
                      type="checkbox"
                    />
                    <CheckboxTitle>Pagamento único</CheckboxTitle>
                  </AlignCheckbox>
                </CheckboxContainer>
              </Col>

            </Row>

            <Row justify="end">
              {can(PortalPermissions.linkPagamento.gerar.gerar) && (
                <Button htmlType="submit">
                  Salvar
                </Button>
              )}
            </Row>


          </Form>
        )}
      </Formik>

    </Container>
  );
}
export default CadastrarLinks;
